import { LDFlags } from '../constants/flags';
import { LienholderOtherSource, isTreatedAsOther } from '../constants/lienholders';
import useFlag from './useFlag';

const useIsSellBlockedLienholder = () => {
  const blockedSlugs = useFlag(LDFlags.MARKETPLACE_BLOCKED_LIENHOLDERS);

  return (data?: LienholderOtherSource | null) =>
    isTreatedAsOther(data) ||
    // LD doesn't enforce JSON flag shape; a malformed value must not break submit.
    (Array.isArray(blockedSlugs) &&
      !!data?.lienholder_slug &&
      blockedSlugs.includes(data.lienholder_slug));
};

export default useIsSellBlockedLienholder;
